module.exports = __webpack_public_path__ + "static/media/search-logo.540345c0.svg";